/* Dependencies
 ---------------------------------------------------------- */
import { Application } from 'wrapper6';

/* Vendor
 ---------------------------------------------------------- */
import '../utils/polyfill/_closest'
import '../utils/polyfill/_append'
import '../utils/polyfill/_object.assign'
import '../utils/polyfill/_array.from'

import '../utils/_serialize-form';

/* Services
 ---------------------------------------------------------- */

/* Register services
 ---------------------------------------------------------- */

/* Modules
 ---------------------------------------------------------- */
import PartnerAds from '../modules/_partner-ads.js';
import Navigation from '../modules/_navigation.js';
import ObjectFit from '../modules/_object-fit.js';
import Print from '../modules/_print.js';
import ArticlesFilter from '../modules/_articles-filter.js';
import SocialShare from '../modules/_social-share.js';
import ReviewSlider from '../modules/_review-slider.js';
import CoursesFilter from '../modules/_courses-filter.js';
import Search from '../modules/_search.js';
import Sticky from '../modules/_sticky.js';
import MobileSlider from '../modules/_mobile-slider.js';
import ScrollToElements from '../modules/_scroll-to-elements.js';
import Tooltip from '../modules/_tooltip.js';
import Scrollto from '../modules/_scrollto';
import VideoModal from '../modules/_video-modal';
import ModuleSlider from '../modules/_module-slider';
import CourseImageSlider from '../modules/_course-image-slider';
import RelatedSlider from '../modules/_related-slider';
import LecturerToggle from '../modules/_lecturer-toggle';
import Newsletter from '../modules/_newsletter';
import NavFilter from '../modules/_nav-filter';
import AudioPlayer from '../modules/_audio-player';
import EventInfobox from '../modules/_event_infobox';
import CalendarFilter from '../modules/_calender-filter';
import PostLiker from '../modules/_post-liker';
import QuickSignup from '../modules/_quick-signup';
import LoadMoreItems from '../modules/_load_more_items';
import ScrollToTop from '../modules/_scroll-to-top';
import EventLandingpage from '../modules/_event-landingpage';
import Gumshoe from '../modules/_gumshoe';
import Foldout from '../modules/_fold-out';
import Accordion from '../modules/_accordion';
import Modal from "../modules/_modal";
import AddToCart from '../modules/_add-to-cart'
import GA4TrackingHandler from '../modules/_ga4-tracking-handler'

/* Setup
 ---------------------------------------------------------- */
let app = window.app = new Application(window.options || {})

/* Register modules
 ---------------------------------------------------------- */
app.use(PartnerAds)
app.use(Navigation)
app.use(ObjectFit)
app.use(Print)
app.use(ArticlesFilter)
app.use(SocialShare)
app.use(ReviewSlider)
app.use(CoursesFilter)
app.use(Search)
app.use(Sticky)
app.use(MobileSlider)
app.use(ScrollToElements)
app.use(Tooltip)
app.use(Scrollto)
app.use(VideoModal)
app.use(ModuleSlider)
app.use(CourseImageSlider)
app.use(LecturerToggle)
app.use(Newsletter)
app.use(NavFilter)
app.use(AudioPlayer)
app.use(EventInfobox)
app.use(CalendarFilter)
app.use(PostLiker)
app.use(QuickSignup)
app.use(LoadMoreItems)
app.use(ScrollToTop)
app.use(EventLandingpage)
app.use(Gumshoe)
app.use(RelatedSlider)
app.use(Foldout)
app.use(Accordion)
app.use(Modal)
app.use(AddToCart)
app.use(GA4TrackingHandler)